import { Injectable } from '@angular/core';
import { Role } from '~app/shared/enums/role.enum';
import { Country } from '~app/shared/models/country.model';
import { EffectItem } from '~app/shared/models/effectItem.model';
import { PhoneType } from '~app/shared/models/phoneType/phoneType.model';
import { Policy } from '~app/shared/models/policy/policy.model';
import { Port } from '~app/shared/models/port.model';
import { Ship } from '~app/shared/models/ship.model';
import { User } from '~app/shared/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  public ships: Array<Ship>;
  public ports: Array<Port>;
  public countries: Array<Country>;
  public effectItems: Array<EffectItem>;
  public phoneTypes: Array<PhoneType>;
  public openRateModal: boolean;
  public symptoms: Array<{ key: string; value: string }>;
  public questions: Array<{ key: string; value: string }>;
  public policies: Array<Policy> = [];

  public currentUser: User;

  public dashboard: {
    selectedShip?: Ship;
    selectedRole?: Role;
    managerId?: string;
  } = {};
}
